import { VersionedFileEntityType } from '@nkr/enums/index';

export interface IFileItem {
    label: string,
    entityType: VersionedFileEntityType
}